module.exports = __webpack_public_path__ + "static/media/The_hypno_virus_turns_me_on.353b7129.mp3";